import { Flow_0_0_2 } from '@flexus/core';

export const BET_170: Flow_0_0_2 = {
	id: '170',
	name: 'warranty_void',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
